import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  equalsLowerCase1477z9rxwgcv2 as equalsLowerCase,
  hashCodeLowerCase2r6jfpu8gi2u9 as hashCodeLowerCase,
} from './internals/Chars.mjs';
import { abs1kdzbjes1idip as abs } from '../../../../../kotlin-kotlin-stdlib/kotlin/math/math.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  SequenceScope1coiso86pqzq2 as SequenceScope,
  sequence2vgswtrxvqoa7 as sequence,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/sequences/SequenceBuilder.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { DefaultPool2gb1fm4epwgu9 as DefaultPool } from '../../../../../ktor-ktor-io/io/ktor/utils/io/pool/DefaultPool.mjs';
import { fill2542d4m9l93pn as fill } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import { isIntArrayeijsubfngq38 as isIntArray } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_IntArrayPool() {
  _init_properties_HttpHeadersMap_kt__hwatby();
  return IntArrayPool;
}
var IntArrayPool;
function get_HeadersDataPool() {
  _init_properties_HttpHeadersMap_kt__hwatby();
  return HeadersDataPool;
}
var HeadersDataPool;
function thresholdReached($this) {
  return $this.b57_1 >= $this.c57_1 * 0.75;
}
function resize($this) {
  var prevSize = $this.b57_1;
  var prevData = $this.d57_1;
  $this.b57_1 = 0;
  $this.c57_1 = imul($this.c57_1, 2) | 128;
  var tmp = $this;
  // Inline function 'kotlin.apply' call
  var this_0 = get_HeadersDataPool().g4m();
  this_0.g57(imul(prevData.f57(), 2) | 1);
  tmp.d57_1 = this_0;
  var _iterator__ex2g4s = prevData.h57().u1();
  while (_iterator__ex2g4s.v1()) {
    var headerOffset = _iterator__ex2g4s.w1();
    $this.j57(prevData.i57(headerOffset + 1 | 0), prevData.i57(headerOffset + 2 | 0), prevData.i57(headerOffset + 3 | 0), prevData.i57(headerOffset + 4 | 0));
  }
  get_HeadersDataPool().h4m(prevData);
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.require' call
  if (!(prevSize === $this.b57_1)) {
    var message = 'Failed requirement.';
    throw IllegalArgumentException().s2(toString(message));
  }
}
function headerHasName($this, name, headerOffset) {
  var nameStartIndex = $this.d57_1.i57(headerOffset + 1 | 0);
  var nameEndIndex = $this.d57_1.i57(headerOffset + 2 | 0);
  return equalsLowerCase($this.a57_1, nameStartIndex, nameEndIndex, name);
}
var HttpHeadersMapClass;
function HttpHeadersMap() {
  if (HttpHeadersMapClass === VOID) {
    class $ {
      constructor(builder) {
        this.a57_1 = builder;
        this.b57_1 = 0;
        this.c57_1 = 0;
        this.d57_1 = get_HeadersDataPool().g4m();
      }
      w2o(name) {
        if (this.b57_1 === 0)
          return null;
        // Inline function 'kotlin.math.absoluteValue' call
        var this_0 = hashCodeLowerCase(name);
        var hash = abs(this_0);
        var headerIndex = hash % this.c57_1 | 0;
        while (!(this.d57_1.i57(imul(headerIndex, 6) + 0 | 0) === -1)) {
          if (headerHasName(this, name, imul(headerIndex, 6))) {
            return this.k57(imul(headerIndex, 6));
          }
          headerIndex = (headerIndex + 1 | 0) % this.c57_1 | 0;
        }
        return null;
      }
      l57() {
        return this.d57_1.h57();
      }
      j57(nameStartIndex, nameEndIndex, valueStartIndex, valueEndIndex) {
        if (thresholdReached(this)) {
          resize(this);
        }
        // Inline function 'kotlin.math.absoluteValue' call
        var this_0 = hashCodeLowerCase(this.a57_1, nameStartIndex, nameEndIndex);
        var hash = abs(this_0);
        var name = this.a57_1.c(nameStartIndex, nameEndIndex);
        var headerIndex = hash % this.c57_1 | 0;
        var sameNameHeaderIndex = -1;
        while (!(this.d57_1.i57(imul(headerIndex, 6) + 0 | 0) === -1)) {
          if (headerHasName(this, name, imul(headerIndex, 6))) {
            sameNameHeaderIndex = headerIndex;
          }
          headerIndex = (headerIndex + 1 | 0) % this.c57_1 | 0;
        }
        var headerOffset = imul(headerIndex, 6);
        this.d57_1.t57(headerOffset + 0 | 0, hash);
        this.d57_1.t57(headerOffset + 1 | 0, nameStartIndex);
        this.d57_1.t57(headerOffset + 2 | 0, nameEndIndex);
        this.d57_1.t57(headerOffset + 3 | 0, valueStartIndex);
        this.d57_1.t57(headerOffset + 4 | 0, valueEndIndex);
        this.d57_1.t57(headerOffset + 5 | 0, -1);
        if (!(sameNameHeaderIndex === -1)) {
          this.d57_1.t57(imul(sameNameHeaderIndex, 6) + 5 | 0, headerIndex);
        }
        this.b57_1 = this.b57_1 + 1 | 0;
      }
      u57(headerOffset) {
        var nameStartIndex = this.d57_1.i57(headerOffset + 1 | 0);
        var nameEndIndex = this.d57_1.i57(headerOffset + 2 | 0);
        return this.a57_1.c(nameStartIndex, nameEndIndex);
      }
      k57(headerOffset) {
        var valueStartIndex = this.d57_1.i57(headerOffset + 3 | 0);
        var valueEndIndex = this.d57_1.i57(headerOffset + 4 | 0);
        return this.a57_1.c(valueStartIndex, valueEndIndex);
      }
      t2m() {
        this.b57_1 = 0;
        this.c57_1 = 0;
        get_HeadersDataPool().h4m(this.d57_1);
        this.d57_1 = get_HeadersDataPool().g4m();
      }
      toString() {
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder().q1();
        dumpTo(this, '', this_0);
        return this_0.toString();
      }
    }
    initMetadataForClass($, 'HttpHeadersMap');
    HttpHeadersMapClass = $;
  }
  return HttpHeadersMapClass;
}
function *_generator_invoke__zhh2q8($this, $this$sequence, $completion) {
  var joinedIndex = 0;
  var _iterator__ex2g4s = $this.v57_1.e57_1.u1();
  while (_iterator__ex2g4s.v1()) {
    var arr = _iterator__ex2g4s.w1();
    var localIndex = 0;
    while (localIndex < arr.length) {
      if (!($this.v57_1.i57(joinedIndex + 0 | 0) === -1)) {
        var tmp = $this$sequence.vk(joinedIndex, $completion);
        if (tmp === get_COROUTINE_SUSPENDED())
          tmp = yield tmp;
      }
      localIndex = localIndex + 6 | 0;
      joinedIndex = joinedIndex + 6 | 0;
    }
  }
  return Unit_instance;
}
var HeadersData$headersStarts$slambdaClass;
function HeadersData$headersStarts$slambda() {
  if (HeadersData$headersStarts$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.v57_1 = this$0;
      }
      w57($this$sequence, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$sequence), $completion);
      }
      ud(p1, $completion) {
        return this.w57(p1 instanceof SequenceScope() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    HeadersData$headersStarts$slambdaClass = $;
  }
  return HeadersData$headersStarts$slambdaClass;
}
function HeadersData$headersStarts$slambda_0(this$0) {
  var i = new (HeadersData$headersStarts$slambda())(this$0);
  var l = ($this$sequence, $completion) => i.w57($this$sequence, $completion);
  l.$arity = 1;
  return l;
}
var HeadersDataClass;
function HeadersData() {
  if (HeadersDataClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.e57_1 = ArrayList().u2();
      }
      f57() {
        return this.e57_1.v2();
      }
      g57(subArraysCount) {
        // Inline function 'kotlin.repeat' call
        var inductionVariable = 0;
        if (inductionVariable < subArraysCount)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            this.e57_1.n2(get_IntArrayPool().g4m());
          }
           while (inductionVariable < subArraysCount);
      }
      i57(index) {
        return this.e57_1.w2(index / 768 | 0)[index % 768 | 0];
      }
      t57(index, value) {
        this.e57_1.w2(index / 768 | 0)[index % 768 | 0] = value;
      }
      h57() {
        return sequence(HeadersData$headersStarts$slambda_0(this));
      }
      t2m() {
        var _iterator__ex2g4s = this.e57_1.u1();
        while (_iterator__ex2g4s.v1()) {
          var array = _iterator__ex2g4s.w1();
          get_IntArrayPool().h4m(array);
        }
        this.e57_1.f5();
      }
    }
    initMetadataForClass($, 'HeadersData', HeadersData);
    HeadersDataClass = $;
  }
  return HeadersDataClass;
}
function dumpTo(_this__u8e3s4, indent, out) {
  _init_properties_HttpHeadersMap_kt__hwatby();
  var _iterator__ex2g4s = _this__u8e3s4.l57().u1();
  while (_iterator__ex2g4s.v1()) {
    var offset = _iterator__ex2g4s.w1();
    out.t2(indent);
    out.t2(_this__u8e3s4.u57(offset));
    out.t2(' => ');
    out.t2(_this__u8e3s4.k57(offset));
    out.t2('\n');
  }
}
var IntArrayPool$1Class;
function IntArrayPool$1() {
  if (IntArrayPool$1Class === VOID) {
    class $ extends DefaultPool() {
      constructor() {
        super(1000);
      }
      z4l() {
        var tmp = 0;
        var tmp_0 = new Int32Array(768);
        while (tmp < 768) {
          tmp_0[tmp] = -1;
          tmp = tmp + 1 | 0;
        }
        return tmp_0;
      }
      a58(instance) {
        fill(instance, -1);
        return protoOf(DefaultPool()).e4m.call(this, instance);
      }
      e4m(instance) {
        return this.a58(isIntArray(instance) ? instance : THROW_CCE());
      }
    }
    initMetadataForClass($);
    IntArrayPool$1Class = $;
  }
  return IntArrayPool$1Class;
}
var HeadersDataPool$1Class;
function HeadersDataPool$1() {
  if (HeadersDataPool$1Class === VOID) {
    class $ extends DefaultPool() {
      constructor() {
        super(1000);
      }
      z4l() {
        return new (HeadersData())();
      }
      e58(instance) {
        instance.t2m();
        return protoOf(DefaultPool()).e4m.call(this, instance);
      }
      e4m(instance) {
        return this.e58(instance instanceof HeadersData() ? instance : THROW_CCE());
      }
    }
    initMetadataForClass($);
    HeadersDataPool$1Class = $;
  }
  return HeadersDataPool$1Class;
}
var properties_initialized_HttpHeadersMap_kt_kotj4w;
function _init_properties_HttpHeadersMap_kt__hwatby() {
  if (!properties_initialized_HttpHeadersMap_kt_kotj4w) {
    properties_initialized_HttpHeadersMap_kt_kotj4w = true;
    IntArrayPool = new (IntArrayPool$1())();
    HeadersDataPool = new (HeadersDataPool$1())();
  }
}
//region block: exports
export {
  HttpHeadersMap as HttpHeadersMapp7szignu4ex,
};
//endregion

//# sourceMappingURL=HttpHeadersMap.mjs.map
